<template>
    <v-container fluid class="pa-3" v-if="sessionActive">

        <material-header title="Announcements"
                         info="Create new announcements to Sample Ninja users"
                         icon="mdi-message-outline">
        </material-header>

        <v-alert v-if="!hasRole('Super Admin')"
                 class="body-2"
                 type="error"
        >
            Your user account doesn't have sufficient permissions to use this feature
        </v-alert>

        <v-card flat v-if="hasRole('Super Admin')">
            <v-card-text>

                <v-row>

                    <v-col cols="6" class="pt-0">

                        <v-card flat>
                            <v-card-text>

                                <v-row v-if="hasRole('Super Admin')">

                                    <v-col cols="12" class="pt-0">

                                        <v-alert type="info" class="body-2">
                                            Announcements will be broadcast to all users and will appear in the application notifications bar.
                                            This is a place to notify users about new features and things like upcoming maintenance windows.
                                        </v-alert>

                                    </v-col>

                                    <v-col cols="12" class="pt-0">

                                        <v-textarea
                                                auto-focus
                                                counter
                                                label="Announcement text"
                                                :error-messages="errors.body ? errors.body : []"
                                                v-model="data.body"
                                                rows="6"
                                                auto-grow
                                        ></v-textarea>

                                    </v-col>

                                    <v-col cols="12" class="pt-0">

                                        <v-text-field
                                                :error-messages="errors.action_text ? errors.action_text : []"
                                                label="Action text"
                                                v-model="data.action_text"
                                                hint="This field is optional"
                                        ></v-text-field>

                                    </v-col>

                                    <v-col cols="12" class="pt-0">

                                        <v-text-field
                                                :error-messages="errors.action_url ? errors.action_url : []"
                                                label="Action URL"
                                                v-model="data.action_url"
                                                hint="This field is optional"
                                        ></v-text-field>

                                    </v-col>

                                    <v-col cols="12" class="pt-0">
                                        <v-btn color="primary" :loading="saving" @click="createAnnouncementClicked">Create</v-btn>
                                    </v-col>

                                </v-row>
                            </v-card-text>
                        </v-card>
                    </v-col>

                </v-row>
            </v-card-text>
        </v-card>

    </v-container>
</template>

<script>

    import Json from 'vue-json-pretty';
    import Store from '../store';
    import {mapState, mapMutations, mapGetters, mapActions} from 'vuex';
    import activeSessionChecker from '../../../components/mixins/activeSessionCheckerMixin';
    import MaterialHeader from '../../../components/UI/MaterialHeader';
    import ToolbarPage from '../../../components/UI/ToolbarPage';

    const vuexModule = 'Announcements';

    export default {

        mixins: [activeSessionChecker],

        components: {
            ToolbarPage,
            Json,
            MaterialHeader
        },

        data() {
            return {
                data: {
                    body: null,
                    action_text: null,
                    action_url: null
                },
                errors: {},
                saving: false,
            }
        },
        computed: {

            ...mapState([
                'announcements',
                'loading'
            ]),
        },

        methods: {

            ...mapActions(vuexModule, [
                'createAnnouncement'
            ]),

            createAnnouncementClicked() {

                this.saving = true;

                this.createAnnouncement(this.data)
                    .then (() => {

                        this.data.body = '';
                        this.data.action_text = '';
                        this.data.action_url = '';

                        Bus.$emit('flash-message', {message: 'New announcement created!'});

                        this.saving = false;
                    })
                    .catch((error) => {
                        if (error.response.status === 422) {
                            this.errors = error.response.data.errors;
                        }
                        this.saving=false;
                    });
            }
        },

        created() {
            if (!this.$store.state[vuexModule]) {
                this.$store.registerModule(vuexModule, Store);
            }
        }
    }

</script>
